import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPurchasedPrivateMediaByPaidUser } from '../../api/purchasedPrivateMediaApi';

// Отримати всі куплені медіа для конкретного paidUser
export const fetchPurchasedPrivateMedia = createAsyncThunk(
  'purchasedPrivateMedia/fetchPurchasedPrivateMedia',
  async (paidUserId, thunkAPI) => {
    try {
      const response = await getPurchasedPrivateMediaByPaidUser(paidUserId);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message,
      );
    }
  },
);
